module.exports = __webpack_public_path__ + "img/404.3507deb4.svg";